export const getLocalCurrentCenter = () => {
  if (!localStorage.getItem('currentCenter')) return null
  const center = JSON.parse(localStorage.getItem('currentCenter'))
  return center.length === 2 ? center : null
}
